//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconNavTables(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M12 2.9978H21.0022V7.49897H12V2.9978Z" fill="currentColor" /><path d="M12 7.49897L2.99756 7.4989V12.0001H11.9997L12 7.49897Z" fill="currentColor" /><path d="M11.9997 12.0001L21.0022 12V16.5012H12L11.9997 12.0001Z" fill="currentColor" /><path d="M2.99756 16.5011L12 16.5012L11.9997 21.0023H2.99756V16.5011Z" fill="currentColor" /></svg>;
}
export default IconNavTables;